import React, { useState } from "react";
import { useSearchParams, useNavigate, Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import PublicHeader from "@/components/layout/PublicHeader";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import api, { formatApiErrorDetail } from "@/lib/api";
import { toast } from "sonner";

export default function ResetPassword() {
  const { t } = useTranslation();
  const [params] = useSearchParams();
  const nav = useNavigate();
  const token = params.get("token") || "";
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (password !== confirm) return toast.error(t("auth.passwordsDontMatch"));
    if (password.length < 6) return toast.error(t("auth.minChars"));
    setBusy(true);
    try {
      await api.post("/auth/reset-password", { token, password });
      toast.success(t("auth.passwordUpdated"));
      nav("/login");
    } catch (e2) {
      toast.error(formatApiErrorDetail(e2.response?.data?.detail));
    } finally { setBusy(false); }
  };

  return (
    <div data-testid="reset-page" className="min-h-screen bg-background">
      <PublicHeader />
      <section className="max-w-md mx-auto px-6 py-16">
        <div className="overline text-primary mb-3">{t("auth.resetTitle").toUpperCase()}</div>
        <h1 className="font-heading text-4xl font-extrabold tracking-tight text-secondary leading-tight">{t("auth.resetTitle")}</h1>
        {!token && <p className="mt-4 text-destructive text-sm">{t("auth.invalidToken")}</p>}
        <form onSubmit={submit} className="mt-8 space-y-4" data-testid="reset-form">
          <div><Label htmlFor="p1">{t("auth.newPassword")}</Label><Input id="p1" data-testid="reset-password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} required minLength={6} /></div>
          <div><Label htmlFor="p2">{t("auth.confirmNew")}</Label><Input id="p2" data-testid="reset-confirm" type="password" value={confirm} onChange={(e) => setConfirm(e.target.value)} required /></div>
          <Button data-testid="reset-submit" disabled={busy || !token} type="submit" className="w-full h-11">{busy ? t("auth.saving") : t("auth.updatePassword")}</Button>
          <div className="text-center"><Link to="/login" className="text-sm text-muted-foreground hover:text-primary">{t("auth.backToLogin")}</Link></div>
        </form>
      </section>
    </div>
  );
}
